import { BUTTON_PRESS } from '@/utils/analytics'

// Published Mixpanel event name — also fired by the legacy v1 modal
// (components/AioEvalResultsModal.tsx). Renaming it breaks saved reports.
export const AIO_EVAL_RESULTS_OPENED = 'AIO Eval Results Opened'

/**
 * Published Mixpanel event name, fired from every way the SOP drawer closes —
 * the header close buttons, the toggle, and the dark drawer's Escape handler —
 * each passing its own `closed_via`. Renaming it breaks saved reports.
 *
 * The two legacy-tree call sites (`sop-incident-drawer/components/`) still
 * inline the string; they are pre-existing and left alone rather than swept.
 * Point them here when next editing those files.
 */
export const SOP_INCIDENT_DRAWER_CLOSE = `${BUTTON_PRESS} SOP Incident Drawer Close`

/**
 * Published Mixpanel event names for the Incident Drawer Map Panel. Open fires
 * from the breadcrumb toggle button (the panel's only open path); Close fires
 * from every user-initiated close — the toggle button, the header close
 * button, and Escape — each passing its own `closed_via`. Programmatic closes
 * (sibling mutual exclusivity, breakpoint force-close, incident drawer close)
 * are not user actions and are untracked, matching the SOP drawer.
 */
export const MAP_PANEL_DRAWER_OPEN = `${BUTTON_PRESS} Incident Drawer Map Panel Open`
export const MAP_PANEL_DRAWER_CLOSE = `${BUTTON_PRESS} Incident Drawer Map Panel Close`
